<template>
  <b-col md="12" sm="8">
    <b-card no-body class="mx-4">
      <b-card-body class="p-4">
        <b-form v-on:submit.prevent="onSubmit">
          <h1 v-if="!editar && !visualizar"><strong>Cadastrar Administrador</strong></h1>
          <h1 v-if="editar"><strong>Editar Administrador</strong></h1>
          <h1 v-if="visualizar"><strong>Visualizar Administrador</strong></h1>
          <b-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group label="CPF:">
                <b-input-group class="mb-3">
                  <b-form-input v-mask="'###.###.###-##'" type="text" class="form-control" placeholder="CPF"
                    autocomplete="cpf" v-model="$v.form.cpf.$model" :state="chkState('cpf')" autofocus
                    :disabled="disable_buttons || visualizar || editar || vincular" />
                  <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="Nome" autocomplete="nome"
                    v-model.trim="$v.form.nome.$model" :state="chkState('nome')"
                    :disabled="disable_buttons || visualizar || editar || vincular" />
                  <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group label="E-mail:">
                <b-input-group class="mb-3">
                  <b-form-input type="text" class="form-control" placeholder="E-mail" autocomplete="email"
                    v-model.trim="$v.form.email.$model" :state="chkState('email')"
                    :disabled="disable_buttons || visualizar || editar || vincular" />
                  <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                    endereço de e-mail válido.
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
              <b-form-group label="Perfil:">
                <b-form-select v-model.trim="$v.form.perfil_id.$model" :state="chkState('perfil_id')"
                  placeholder="Tipo de Usuário" class="mb-3" :disabled="disable_buttons || visualizar">
                  <option :value="null">Selecione...</option>
                  <option v-for="item in perfis" :key="item.id" :value="item.id"> {{ item.nome }}</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6" lg="6">
              <b-form-group label="Formulário de Referência:">
                <b-form-select v-model.trim="$v.form.formulario_id.$model" class="mb-3" :state="chkState('formulario_id')"
                  @change="getPerguntasFormulario()" :disabled="disable_buttons || visualizar || disable_formulario">
                  <option :value="null">Selecione...</option>
                  <option v-for="item in formularios" :value="item.id" :key="item.id"> {{ item.titulo }}</option>
                </b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback3">O formuário é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <span>
                <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                  class="table table-responsive-sm table-bordered table-striped table-sm">
                  <thead>
                    <tr>
                      <th scope="col" tabindex="0" style="width: 46%">Pergunta</th>
                      <th scope="col" tabindex="0" style="width: 46%">Resposta</th>
                      <th scope="col" tabindex="0" style="width: 8%">Ações</th>
                    </tr>
                  </thead>
                  <tbody v-if="form.perguntas_formulario.length > 0">
                    <tr v-for="(perguntas, index) in form.perguntas_formulario" :key="perguntas.id" class="action">
                      <td>
                        <b-form-select :disabled="disable_buttons || visualizar" @change="getRespostas($event, index)"
                          v-model="perguntas.perguntas_selecionadas" class="mb-3">
                          <option selected :value="null">Selecione</option>
                          <option v-for="pergunta in perguntas.perguntas" :key="pergunta.id" :value="pergunta.id">
                            {{ pergunta.titulo }}</option>
                        </b-form-select>
                      </td>
                      <td>
                        <b-form-select :disabled="disable_buttons || visualizar"
                          v-model="perguntas.alternativas_selecionadas" class="mb-3">
                          <option selected :value="null">Selecione</option>
                          <option v-for="alternativa in perguntas.respostas" :key="alternativa.id"
                            :value="alternativa.id">{{ alternativa.resposta }}</option>
                        </b-form-select>
                      </td>
                      <td style="width: 8%">
                        <b-button tabindex="0" :disabled="disable_buttons || visualizar" v-if="index > 0"
                          class="btn btn-sm btn-secondary action" @click="removerPergunta(index)">
                          <i class="fa fa-minus"></i>
                        </b-button>
                        <b-button tabindex="0" :disabled="disable_buttons || visualizar"
                          class="btn btn-sm btn-danger action" @click="adicionarPergunta(index)">
                          <i class="fa fa-plus"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="action">
                      <td colspan="6" tabindex="0">Nenhuma pergunta para o formulário</td>
                    </tr>
                  </tbody>
                </table>
              </span>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col v-if="!loading && !visualizar" sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
              <i class="fa fa-plus"></i>&nbsp;
              <span v-if="!vincular">Salvar</span>
              <span v-if="vincular">Vincular</span>
            </b-button>
          </b-col>
          <b-col v-if="loading && !visualizar" sm="12" md="4" lg="3" style="padding-bottom: 5px;">
            <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
              <b-spinner small type="grow"></b-spinner>Salvando...
            </b-button>
          </b-col>
          <b-col sm="12" md="4" lg="3">
            <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/administradores')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, minLength, email, sameAs, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      nome: {
        required
      },
      email: {
        required,
        email
      },
      perfil_id: {
        required
      },
      formulario_id: {
        required: requiredIf(function () {
          return this.form.perfil_id === 10
        })
      },
    }
  },
  created() {
    this.$store.dispatch('getPerfisAdministrador')
    this.carregarFormularios()

    if (this.$route.params.id) {
      this.load(this.$route.params.id)


      let path = this.$route.path
      path = path.split('/')

      if (path[3] === 'editar') {
        this.editar = true
      }

      if (path[3] === 'visualizar') {
        this.visualizar = true
      }
    }

  },
  watch: {
    'form.perfil_id': function () {
      this.form.perguntas_formulario = []
      if (this.form.perfil_id == 10) {
        this.disable_formulario = false
      } else {
        this.form.formulario_id = null
        this.disable_formulario = true
      }
    },
    'form.cpf': function () {
      if (this.form.cpf.length == 14 && !this.editar && !this.visualizar) {
        this.buscaUsuarioCpf(this.form.cpf)
      }
    }
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        cpf: '',
        perfil_id: null,
        formulario_id: null,
        perguntas_formulario: [],
        nome: '',
        email: '',
      },
      perfil_local_respostas: [],
      formularios: [],
      disable_buttons: false,
      disable_formulario: true,
      visualizar: false,
      editar: false,
      vincular: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
    }
  },
  computed: {
    perfis() {
      return this.$store.state.perfil.listaAdministrador
    },
    isValid() {
      return !this.$v.form.$anyError
    },
    isValidSelection() {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    salvar() {
      let form = this.$v.form
      let data = {
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        nome: form.nome.$model,
        email: form.email.$model,
        email_confirmation: form.email.$model,
        perguntas_formulario: this.form.perguntas_formulario,
        ativo: true,
        perfis: JSON.stringify([{ id: form.perfil_id.$model }]),
        gerarToken: false
      }

      this.loading = true

      Vue.http.post('api/usuario', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/administradores' })
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    alterar() {
      let form = this.$v.form
      let data = {
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        nome: form.nome.$model,
        email: form.email.$model,
        email_confirmation: form.email.$model,
        perguntas_formulario: this.form.perguntas_formulario,
        ativo: true,
        perfis: form.perfil_id.$model,
        gerarToken: false
      }

      this.loading = true

      Vue.http.put('api/usuario/' + this.form.id, data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({ path: '/administradores' })
        } else {
          miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar() {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          if (this.form.id) {
            this.alterar()
          } else {
            this.salvar()
          }
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit() {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState(val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    load(id) {
      Vue.http.get('api/usuario/showAdministrador/' + id).then(response => {
        if (response.body.success) {
          let data = response.body.data[0]

          this.form.id = data.id
          this.form.cpf = data.cpf
          this.form.nome = data.nome
          this.form.email = data.email
          this.form.perfil_id = data.user_perfil_conferencia[0].perfil_id

          if (data.perfil_local_respostas.length > 0) {
            
            this.form.formulario_id = data.perfil_local_respostas[0].formulario_id
            let formulario_servico_id = data.perfil_local_respostas[0].formulario.formulario_servico_id
            
            Vue.http.get('api/formulario/buscarPerguntasRespostas/' + formulario_servico_id).then(response => {
              if (response.body.data.dados) {
                data.perfil_local_respostas.forEach(respostas => {
                  this.form.perguntas_formulario.push({
                    id: respostas.id,
                    formulario_id: respostas.formulario_id,
                    perguntas: response.body.data.dados,
                    respostas: response.body.data.dados[respostas.pergunta_id]['opcoes_perguntas_dependentes'],
                    perguntas_selecionadas: respostas.pergunta_id,
                    alternativas_selecionadas: respostas.alternativa_id,
                  })
                })
              }
            })
          }
        }
      })
    },
    carregarFormularios() {
      Vue.http.get('api/formulario/relacionados/' + true).then(response => {
        if (response.body.success) {
          this.formularios = response.body.data
        }
      })
    },
    getPerguntasFormulario() {
      if (this.form.formulario_id) {
        this.form.perguntas_formulario = []

        let formulario_servico_id = null
        for (let i in this.formularios) {
          if (this.form.formulario_id == this.formularios[i].id) {
            formulario_servico_id = this.formularios[i].formulario_servico_id
          }
        }

        Vue.http.get('api/formulario/buscarPerguntasRespostas/' + formulario_servico_id).then(response => {
          if (response.body.success) {
            if (response.body.data.dados) {
              this.form.perguntas_formulario.push({
                id: null,
                formulario_id: this.form.formulario_id,
                perguntas: response.body.data.dados,
                respostas: [],
                perguntas_selecionadas: null,
                alternativas_selecionadas: null,
              })
            }
          }
        })
      }
    },
    getRespostas(event, index) {
      this.form.perguntas_formulario[index].respostas.splice(index, 0)
      this.form.perguntas_formulario[index].respostas = this.form.perguntas_formulario[index].perguntas[event]['opcoes_perguntas_dependentes']
    },
    adicionarPergunta(index) {
      this.form.perguntas_formulario.push({
        id: null,
        formulario_id: this.form.formulario_id,
        perguntas: this.form.perguntas_formulario[index].perguntas,
        respostas: [],
        perguntas_selecionadas: null,
        alternativas_selecionadas: null,
      })
    },
    removerPergunta(key) {
      this.form.perguntas_formulario.splice(key, 1)
    },
    buscaUsuarioCpf(cpf) {
      let cpf_format = cpf.replaceAll('.', '').replace('-', '')

      Vue.http.get('api/usuario/buscarCpf/' + cpf_format).then(response => {
        if (response.body.success) {
          if (response.body.data[0]) {

            miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
            miniToastr.success('Usuário já existente, vincule ao perfil desejado!', 'Sucesso!', 7000)

            let user = response.body.data[0]
            this.form.id = user.id
            this.form.nome = user.nome
            this.form.email = user.email

            this.vincular = true
          } else {
            this.vincular = false
            this.form.id = null
            this.form.nome = ''
            this.form.email = ''
          }
        }
      })

    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuariosAdministrador/AdministradorForm.vue